<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Të dhënat e kërkesës</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <form>
            <div class="col-12">
              <div class="white-background mb-30">
                <div class="form-group">
                  <!-- <label>Të dhënat e kërkesës</label> -->
                  <input
                    type="text"
                    placeholder="emri dhe mbiemri"
                    :value="fullName"
                    @input="getFullName"
                  >
                  <input
                    type="text"
                    placeholder="regjistrimi i automjetit"
                    :value="registrationNumber"
                    @input="getRegistrationNumber"
                  >
                  <select
                    style="color: black; paddingTop: 10px; paddingBottom: 10px"
                    class="select-cars width-30"
                    name="vehicle-type"
                    :value="requestStatus"
                    @input="getRequestStatus"
                  >
                    <option style="color: black" value disabled selected>Statusi i kerkeses</option>
                    <option style="color: black" value="rejected">Refuzo</option>
                    <option style="color: black" value="awaiting">Ne pritje</option>
                    <option style="color: black" value="approved">E aprovuar</option>
                    <option style="color: black" value="on_the_way">Rruges</option>
                    <option style="color: black" value="shipped">Ka arritur</option>
                    <option style="color: black" value="done">E perfunduar</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Marka e automjetit"
                    :value="carBrand"
                    @input="getCarBrand"
                  >
                  <input
                    type="text"
                    placeholder="Ngjyra e automjetit"
                    :value="carColor"
                    @input="getCarColor"
                  >
                  <select
                    style="color: black; padding-top: 10px; padding-bottom: 10px"
                    class="select-cars width-30"
                    name="tow-truck"
                    :value="truckId"
                    @input="getTruckId"
                  >
                    <option style="color: black" value disabled selected>Zgjedhni vozitësin</option>
                    <option style="color: black" v-for="truck in availableTrucks" :key="truck.id" :selected="truck.id === truckId" :value="truck.id">{{ `${truck.full_name}` }}</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Longitude"
                    :value="longitude"
                    @input="getLongitude"
                  >
                  <input type="text" placeholder="Latitude" :value="latitude" @input="getLatitude">
                  <input type="text" placeholder="Address" :value="address" @input="getAddress">
                  <p><a :href="`https://www.google.com/maps?q=${latitude},${longitude}`" target="_blank"><strong>Shih Lokacionin ne GoogleMaps</strong></a></p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="confirmation">
                <!-- <router-link tag="button" to="/admin">anulo</router-link> -->
                <button type @click="rejectRequest">anulo</button>
                <button :style="buttonStyle" :class="{'disabled-button' : disableConfirmButton(), 'enabled-button' : !disableConfirmButton()}" :disabled="disableConfirmButton()" type @click="updateRequestDetail">konfirmo</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";

export default {
  name: "AdminRequestDetail",
  components: {
    AdminSidebar: AdminSidebar
  },
  methods: {
    getFullName(e) {
      this.$store.dispatch("requests/getFullName", e.target.value);
    },
    getLongitude(e) {
      this.$store.dispatch("requests/getLongitude", e.target.value);
    },
    getLatitude(e) {
      this.$store.dispatch("requests/getLatitude", e.target.value);
    },
    getCarBrand(e) {
      this.$store.dispatch("requests/getCarBrand", e.target.value);
    },
    getRegistrationNumber(e) {
      this.$store.dispatch("requests/getRegistrationNumber", e.target.value);
    },
    getTruckId(e) {
      this.$store.dispatch("requests/getTruckId", e.target.value);
    },
    getRequestStatus(e) {
      this.$store.dispatch("requests/getRequestStatus", e.target.value);
    },
    getAddress(e) {
      this.$store.dispatch("requests/getAddress", e.target.value);
    },
    getCarColor(e) {
      this.$store.dispatch("requests/getCarColor", e.target.value);
    },
    updateRequestDetail(e) {
      e.preventDefault();
      this.$store.dispatch(
        "requests/updateRequestDetail",
        this.$route.params.id
      );
    },
    rejectRequest(e) {
      e.preventDefault();
      this.$store.dispatch(
        "requests/rejectRequest",
        this.$route.params.id
      );
    },
    disableConfirmButton(){
      if(!this.address || !this.requestStatus || !this.carBrand || !this.carColor || !this.truckId || !this.registrationNumber || !this.longitude || !this.latitude || !this.fullName){
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapGetters({
      fullName: "requests/fullName",
      longitude: "requests/longitude",
      latitude: "requests/latitude",
      carBrand: "requests/carBrand",
      registrationNumber: "requests/registrationNumber",
      truckId: "requests/truckId",
      requestStatus: "requests/requestStatus",
      address: "requests/address",
      carColor: "requests/carColor",
      availableTrucks: "trucks/availableTrucks"
    })
  },
  beforeMount() {
      this.$store.dispatch("trucks/getTrucksList");
      this.$store.dispatch("requests/getRequestDetail", this.$route.params.id);
  }
};
</script>
